export default __webpack_public_path__ + "static/media/multiple-users-silhouette.e1ac672d.svg";